import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { RecognizedMedia } from 'schemas/RecognizedMediaSchema'
import { SocialWebPhotoConceptsWidget } from 'schemas/SocialWebPhotoConceptsWidgetSchema'
import { fromViewOption } from 'utils/detectType'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (
  filter: Filter,
  insights: InsightData[],
  widgetSetting?: SocialWebPhotoConceptsWidget
) => {
  const recognizedMedia: RecognizedMedia = {
    type: fromViewOption(widgetSetting?.viewOption),
    names: insights.map((insight) => insight.enumName || insight.name)
  }
  return {
    ...filter,
    recognizedMedias: [...(filter.recognizedMedias || []), [recognizedMedia]]
  }
}

const generateRecognizedMediaStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateRecognizedMediaStrategy
